import { render, staticRenderFns } from "./survey-result.vue?vue&type=template&id=82da19a6&scoped=true&"
import script from "./survey-result.vue?vue&type=script&lang=js&"
export * from "./survey-result.vue?vue&type=script&lang=js&"
import style0 from "./survey-result.vue?vue&type=style&index=0&id=82da19a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82da19a6",
  null
  
)

export default component.exports